const o = (t, e) => {
  if (t === e) return !0;
  if (typeof t != "object" || typeof e != "object" || !t || !e) return !1;
  const n = Object.keys(t), f = Object.keys(e);
  if (n.length !== f.length) return !1;
  for (const s of n) {
    if (!(s in e)) return !1;
    const l = t[s], r = e[s];
    if (typeof l == "object" && l !== null && typeof r == "object" && r !== null) {
      if (l.isAvailable !== r.isAvailable || l.reason !== r.reason) return !1;
    } else if (l !== r)
      return !1;
  }
  return !0;
};
export {
  o as shallowEqual
};
//# sourceMappingURL=contact-channels57.js.map
